import React from "react";
import Modal from "Common/Components/Modal";
import Flatpickr from "react-flatpickr";
import DiscountInfoForm from "../DiscountInfoForm";
import DiscountJewelleryProduct from "../DiscountJewelleryProduct";
import Tab from "Common/Components/Tab/Tab";
import { Nav } from "Common/Components/Tab/Nav";
import {
  CheckCircle,
  Gem,
  Info,
  PartyPopper,
  Rocket,
  User2,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

interface DiscountModelProps {
  show: boolean; // Ensure the 'show' prop is properly typed
  toggle: () => void;
  eventData: any;
  selectedProducts: any;
  isEdit: boolean;
  validation: any;
  discounts: any;
  showAllProducts: boolean;
  setShowAllProducts: React.Dispatch<React.SetStateAction<boolean>>;
}

const DiscountModel: React.FC<DiscountModelProps> = ({
  show,
  toggle,
  eventData,
  isEdit,
  validation,
  discounts,
  showAllProducts,
  setShowAllProducts,
}) => {
  const navigate = useNavigate();

  const handleAddDiscount = () => {
    // dispatch(onAddJewelleryDiscount(discountInfo));
    toggle();
    navigate("/add-discount");
  };

  return (
    <React.Fragment>
      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed max-h-[90vh] justify-center flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen max-h-[90vh] max-w-[calc(theme('width.screen')_-_3rem)] md:w-[60rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <div className="grid grid-cols-1 2xl:grid-cols-12">
          <div className="col-span-12">
            <div className="card mb-0">
              <div className="card-body">
                <Modal.Header
                  className="flex justify-between items-center border-b pb-4 dark:border-zink-500"
                  closeButtonClass="transition-all pb-4 duration-200 ease-linear text-slate-400 hover:text-red-500"
                >
                  <Modal.Title className="text-16">{isEdit ? "Update Discount" : "Add Discount"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Tab.Container defaultActiveKey="discountInfo">
                    <Nav className="grid grid-cols-3 gap-3 lg:grid-cols-3 nav-tabs form-wizard">
                      <Nav.Item
                        eventKey="discountInfo"
                        className="group/item"
                        allowClick={false}
                      >
                        <a
                          href="#!"
                          data-target="discountInfo"
                          data-tab-id="1"
                          className="block px-4 py-5 text-center rounded-md text-slate-500 bg-slate-50 dark:text-zink-200 dark:bg-zink-600 group-[.active]/item:bg-custom-500 group-[.active]/item:text-custom-50"
                        >
                          <Info className="block h-6 mx-auto fill-slate-200 dark:fill-zink-400 group-[.active]/item:fill-slate-200 dark:group-[.active]/item:fill-custom-500" />
                          <span className="block mt-3 font-medium text-15">
                            1. Discount Info
                          </span>
                        </a>
                      </Nav.Item>
                      <Nav.Item
                        eventKey="discountJewelleryProduct"
                        className="group/item"
                        allowClick={false}
                      >
                        <a
                          href="#!"
                          data-target="discountJewelleryProduct"
                          data-tab-id="2"
                          className="block px-4 py-5 text-center rounded-md text-slate-500 bg-slate-50 dark:text-zink-200 dark:bg-zink-600 group-[.active]/item:bg-custom-500 group-[.active]/item:text-custom-50"
                        >
                          <Gem className="block h-6 mx-auto fill-slate-200 dark:fill-zink-400 group-[.active]/item:fill-slate-200 dark:group-[.active]/item:fill-custom-500" />
                          <span className="block mt-3 font-medium text-15">
                            2. Discount Jewellery Product
                          </span>
                        </a>
                      </Nav.Item>
                      <Nav.Item
                        eventKey="completed"
                        className="group/item"
                        allowClick={false}
                      >
                        <a
                          href="#!"
                          data-target="completed"
                          data-tab-id="3"
                          className="block px-4 py-5 text-center rounded-md text-slate-500 bg-slate-50 dark:text-zink-200 dark:bg-zink-600 group-[.active]/item:bg-custom-500 group-[.active]/item:text-custom-50"
                        >
                          <PartyPopper className="block h-6 mx-auto fill-slate-200 dark:fill-zink-400 group-[.active]/item:fill-slate-200 dark:group-[.active]/item:fill-custom-500" />
                          <span className="block mt-3 font-medium text-15">
                            3. Completed
                          </span>
                        </a>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content className="tab-content">
                      <Tab.Pane eventKey="discountInfo">
                        <DiscountInfoForm
                          eventData={eventData}
                          //  selectedProducts={selectedProducts}
                          isEdit={isEdit}
                          validation={validation}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="discountJewelleryProduct">
                        <DiscountJewelleryProduct
                          eventData={eventData}
                          // selectedProducts={selectedProducts}
                          isEdit={isEdit}
                          toggle={toggle}
                          discounts={discounts}
                          showAllProducts={showAllProducts}
                          setShowAllProducts={setShowAllProducts}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="completed">
                        <div className="px-4 py-6 mx-auto text-center lg:w-2/3">
                          <CheckCircle className="block size-10 mx-auto mb-4 text-green-500 fill-green-100 dark:fill-green-500/20 animate-icons"></CheckCircle>
                          <h5 className="mb-2">Discount Added Successfully</h5>
                          <p className="mb-5 text-slate-500 text-15">
                            We are delighted to inform you that your discount
                            has been successfully added! Thank you for enhancing
                            your offerings with us. Stay tuned for more
                            opportunities to grow and succeed. Happy selling!
                          </p>
                          <button
                            type="button"
                            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                            onClick={handleAddDiscount}
                          >
                            <span className="align-middle">Completed</span>
                          </button>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </Modal.Body>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default DiscountModel;
